import { render, staticRenderFns } from "./EditalEletronico.vue?vue&type=template&id=74aa3758&scoped=true"
import script from "./EditalEletronico.vue?vue&type=script&lang=js"
export * from "./EditalEletronico.vue?vue&type=script&lang=js"
import style0 from "./EditalEletronico.vue?vue&type=style&index=0&id=74aa3758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa3758",
  null
  
)

export default component.exports